// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._1qxuyma0 {
  height: var(--_18w76bwz);
}
@media screen and (min-width: 768px) {
  ._1qxuyma0 {
    flex-basis: calc(33% - 20px);
    height: 120px;
  }
}
@media screen and (min-width: 1024px) {
  ._1qxuyma0 {
    height: 170px;
  }
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@vanilla-extract/webpack-plugin/extracted.js"],"names":[],"mappings":"AAAA;EACE,wBAAwB;AAC1B;AACA;EACE;IACE,4BAA4B;IAC5B,aAAa;EACf;AACF;AACA;EACE;IACE,aAAa;EACf;AACF","sourcesContent":["._1qxuyma0 {\n  height: var(--_18w76bwz);\n}\n@media screen and (min-width: 768px) {\n  ._1qxuyma0 {\n    flex-basis: calc(33% - 20px);\n    height: 120px;\n  }\n}\n@media screen and (min-width: 1024px) {\n  ._1qxuyma0 {\n    height: 170px;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
